import(/* webpackMode: "eager" */ "/home/ubuntu/download/696b35501beda800145232b8/weskill_academy/src/app/not-found.tsx");
